import { gql } from '@apollo/client';

export const residencesQuery = gql`
  query ResidencesQuery {
    residences(sort: RANDOM) {
      id
      name
      city {
        name
      }
      price {
        perUnit
        total {
          minimum
          maximum
        }
        currency
      }
      address
      deadline
      coverUrl
      path
      metroName
      companyName
      updatedAt
    }
  }
`;

export function getResidenceDataQuery(slug) {
  const name = `GetResidenceDataQuery_${slug}`.replace(/[^_0-9A-Za-z]/g, '');
  return gql`
    query ${name}($slug: String!) {
      residence(slug:$slug) {
        id
        address
        logoUrl
        showBrandHeader
        apartmentRooms
        itemRooms
        apartments {
          bathroomsCount
          balconiesCount
          repair {
            name
          }
          area
          currency
          description
          id
          mortgagePriceFrom
          priceFrom
          rooms
          photos {
            full
            f660x496
          }
        }
        briefInfo
        brochureUrl
        city {
          id
          name
        }
        companyName
        contactEmail
        coverUrl
        deadline
        description
        hits
        lat
        lng
        metroName
        name
        phonesMasked
        photos {
          full
          f660x496
        }
        price {
          currency
          perUnit
          total {
            maximum
            minimum
          }
        }
        shortAddress
        updatedAt
        website
        youtubeVideoId
        buildingClass {
          name
        }
        buildingsCount
        blocks
        ceilingHeight
        apartmentsCount
        liftsPerBlock
        floorsPerBuilding
        apartmentsPerFloor
        decoration {
          name
        }
        windowType {
          name
        }
        technology {
          name
        }
        layout {
          name
        }
        hasBillOfSale
        facilities {
          name
          iconUrl
        }
        constructionProgresses {
          name
          date
          youtubeVideoId
          photos {
            full
          }
          isPromo
        }
        infrastructures {
          distance
          infrastructure {
            name
            iconUrl
          }
        }
        specialOffers {
          name
          description
          offerType
        }
        itemsCount
        locations {
          id
          name
          fullName
        }
      }
    }
  `;
}
